const DayPlanner = require('../src/images/DayPlannerSS.png');
const DrinkFinderSS = require('../src/images/DrinkFinderSS.png');
const NoteAppSS = require('../src/images/NoteAppSS.png');
const TechReviewSS = require('../src/images/TechReviewSS.png');
const WeatherSS = require('../src/images/WeatherSS.png');
const WishListSS = require('../src/images/WishListSS.png');
const BusinessConnectSS = require('../src/images/BusinessConnectSS.png');

const projectlist = [
    {
        name: "Business Connect",
        pic: BusinessConnectSS,
        link: "https://business-connect-lgat.herokuapp.com/",
        github: "https://github.com/GarrettLB/Business-Connect",
        alt: "Business Connect App Screenshot"
    },
    {
        name: "Wish List",
        pic: WishListSS,
        link: "https://wish-list-fscg.herokuapp.com/",
        github: "https://github.com/nandodavila/Wish-List",
        alt: "Wish List App Screenshot"
    },
    {
        name: "Drink Finder",
        pic: DrinkFinderSS,
        link: "https://bromarito.github.io/drink-finder/",
        github: "https://github.com/brOmarito/drink-finder",
        alt: "Drink Finder App Screenshot"
    },
    {
        name: "Tech Review",
        pic: TechReviewSS,
        link: "https://gb-tech-review.herokuapp.com/",
        github: "https://github.com/GarrettLB/Tech-Review",
        alt: "Tech Review App Screenshot"
    },
    {
        name: "Weather App",
        pic: WeatherSS,
        link: "https://garrettlb.github.io/Weather-App/",
        github: "https://github.com/GarrettLB/Weather-App",
        alt: "Weather App Screenshot"
    },
    {
        name: "Day Planner",
        pic: DayPlanner,
        link: "https://garrettlb.github.io/Work-Day-Planner/",
        github: "https://github.com/GarrettLB/Work-Day-Planner",
        alt: "Day Planner App Screenshot"
    },{
        name: "Note App",
        pic: NoteAppSS,
        link: "https://glb-note-app.herokuapp.com/",
        github: "https://github.com/GarrettLB/Note-App",
        alt: "Note App Screenshot"
    }
]

export default projectlist